import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    unpaidBreakMinutes?: ?number;
}

export class TimesheetEntryUnpaidBreakMinutes extends React.PureComponent<Props> {
    render() {
        const { unpaidBreakMinutes } = this.props;
        if (!unpaidBreakMinutes) return null;
        return unpaidBreakMinutes;
    }
}

const mapStateToProps = createStructuredSelector({
    unpaidBreakMinutes: makeSelectTimesheetEntryValue('unpaidBreakMinutes')
});

export default connect(mapStateToProps)(TimesheetEntryUnpaidBreakMinutes);
